import { HtmlWidgetServerModelHelper } from './HtmlWidgetServerModel';
import { ContentFragmentType } from '../content/contentBuilder/Content';
import { WidgetType } from '../content/contentBuilder/widgets/widgetType';
import { wrapPropertiesWithWidgetTracking } from '../content/contentBuilder/widgets/WidgetRequirements';
export const HtmlWidgetConverter = {
    convertDomainModel: (widget) => {
        var _a;
        return {
            type: ContentFragmentType.Widget,
            trackingIdentifier: widget.trackingIdentifier,
            _id: widget.id,
            value: {
                type: WidgetType.html,
                data: {
                    assetId: widget.data.assetId,
                },
                properties: wrapPropertiesWithWidgetTracking({ canBeRequired: false, displayDelayInSeconds: (_a = widget.properties.displayDelayInSeconds) !== null && _a !== void 0 ? _a : 0 }, widget.properties.isRequired),
            },
            initialized: true,
        };
    },
    convertToServerModel: (widget) => {
        return HtmlWidgetServerModelHelper.create(widget._id, widget.trackingIdentifier, widget.value.data.assetId, widget.value.properties.isRequired, widget.value.properties.displayDelayInSeconds);
    },
};
